import React from 'react';
import spinner from 'assets/img/spinner.gif';

import './Loader.scss';

export const Loader = () => {
    return (
        <div className="loader">
            <img src={spinner} alt={'Loading...'} className="loaderImg" />
        </div>
    );
};